import { fetchCMSMenuLocations } from '../../common/api/cms';
import { NOT_FOUND } from '../status';

export const FETCH_MENU_LOCATIONS = 'FETCH_MENU_LOCATIONS';
export const FETCH_MENU_LOCATIONS_SUCCESS = 'FETCH_MENU_LOCATIONS_SUCCESS';
export const FETCH_MENU_LOCATIONS_FAILURE = 'FETCH_MENU_LOCATIONS_FAILURE';

export const fetchMenuLocations = () => async (dispatch) => {
  dispatch({
    type: FETCH_MENU_LOCATIONS,
  });
  try {
    const menuLocations = await fetchCMSMenuLocations();
    await dispatch({
      type: FETCH_MENU_LOCATIONS_SUCCESS,
      menuLocations,
    });
  } catch (error) {
    if (error.statusCode === 400) {
      dispatch({
        type: NOT_FOUND,
        message: 'Menu locations could not be found',
      });
    }
    dispatch({
      type: FETCH_MENU_LOCATIONS_FAILURE,
      error,
    });
  }
};



// WEBPACK FOOTER //
// ./src/actions/cms/menuLocations.js